import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item", "className"];
import React from 'react';
import { Label } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import { Highlight } from '../Highlight/Highlight';
import { Row } from './Row';
import i18n from './i18n';
import './StackoverflowRow.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var b = block('search-stackoverflow-row');
export function StackoverflowRow(_ref) {
  var item = _ref.item,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var title = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: b('name'),
      children: /*#__PURE__*/_jsx(Highlight, {
        text: item.title
      })
    }), item.is_answered ? /*#__PURE__*/_jsx(Label, {
      theme: "success",
      className: b('status'),
      children: i18n('context_resolved')
    }) : null]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    title: title,
    item: item,
    className: b(null, className)
  }, otherProps));
}
// #sourceMappingURL=StackoverflowRow.js.map